import React from 'react';
type ButtonVariant = 'primary' | 'secondary' | 'quiet';
type ButtonSize = 'md' | 'lg';
interface ButtonProps extends React.ComponentProps<'button'> {
  variant?: ButtonVariant;
  size?: ButtonSize;
}
const BASE = 'inline-flex items-center justify-center gap-2 rounded-field font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-card disabled:pointer-events-none disabled:opacity-50';
const VARIANTS: Record<ButtonVariant, string> = {
  primary: 'bg-primary text-on-primary hover:bg-primary-hover',
  secondary: 'border border-rule bg-card text-ink hover:bg-canvas',
  quiet: 'text-primary-text hover:bg-primary-soft'
};

/** 44px minimum height on every size — this audience is on a phone at arm's length. */
const SIZES: Record<ButtonSize, string> = {
  md: 'min-h-tap px-4 text-small',
  lg: 'min-h-[3rem] px-6 text-body'
};
export function Button({
  variant = 'primary',
  size = 'md',
  className = '',
  type = 'button',
  ...rest
}: ButtonProps) {
  return <button type={type} className={`${BASE} ${VARIANTS[variant]} ${SIZES[size]} ${className}`} {...rest} data-id="element-506" data-mp="epnyxvw0nl7t" />;
}